<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">Closing</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button"
        (click)="activeModal.dismiss()"></app-svg-icon>
</div>
<form ngNativeValidate #rfidForm="ngForm">
    <div class="modal-body mx-2">
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Loss Wt</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'lossWt'" 
                    [inputId]="'lossWt'" 
                    [inputType]="'text'"
                    [inputValue]="data?.model?.lossWt" 
                    (inputValueEmit)="data.model.lossWt=$event" 
                    [readOnly]="true"
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Work Done(KG)</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'workDone'" 
                    [inputId]="'workDoneId'" 
                    [inputType]="'text'"
                    [inputValue]="data?.model?.workDone" 
                    (inputValueEmit)="data.model.workDone=$event;calculateAvgLossPerKg()" 
                    [decimalRestrictedDigit]="3"
                    [isBlureApplicable]="true" 
                    [applyDecimalOrPercent]="true"
                    [isMinusNeglected]="true"
                    (keydown.enter)="onKeydown($event, 'purityPer')" 
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Avg Loss/ KG</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'avgLossPerKg'" 
                    [inputId]="'avgLossPerKgId'" 
                    [inputType]="'text'"
                    [inputValue]="data?.model?.avgLoss" 
                    (inputValueEmit)="data.model.avgLoss = $event" 
                    [readOnly]="true"
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Purity Per</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'purityPer'" 
                    [inputId]="'purityPer'" 
                    [inputValue]="data?.model?.purityPer"
                    (inputValueEmit)="data.model.purityPer = $event;calculateItem();calculateGoldLossValue()" 
                    [decimalRestrictedDigit]="3"
                    [isBlureApplicable]="true" [applyDecimalOrPercent]="true"
                    (keydown.enter)="onKeydown($event, 'goldRate')" 
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Purity Wt</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'purityWt'" 
                    [inputId]="'purityWt'" 
                    [inputType]="'text'"
                    [inputValue]="data?.model?.purityWt" 
                    (inputValueEmit)="data.model.purityWt=$event"
                    [readOnly]="true"
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Gold Rate</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'goldRate'" 
                    [inputId]="'goldRate'" 
                    [inputValue]="data?.model?.goldRate"
                    (inputValueEmit)="data.model.goldRate = $event;calculateGoldLossValue()" 
                    [decimalRestrictedDigit]="2"
                    [isBlureApplicable]="true" 
                    [applyDecimalOrPercent]="true"
                    (keydown.enter)="onKeydown($event, 'goldLossValue')" 
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Gold Loss Value</div>
            <div class="col ps-0">
                <app-input 
                    [inputName]="'goldLossValue'" 
                    [inputId]="'goldLossValue'"
                    [inputValue]="data?.model?.goldLossValue" 
                    (inputValueEmit)="data.model.goldLossValue = $event;"
                    [decimalRestrictedDigit]="3" 
                    [isBlureApplicable]="true" 
                    [applyDecimalOrPercent]="true"
                    (keydown.enter)="onSave()"
                    >
                </app-input>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-2 font-semibold text-gray-color d-flex align-items-center">Closing Date</div>
            <div class="col ps-0">
                <app-input-datepicker-renderer #closingDateComp [inputDate]="data?.model?.closingDate"
                    [id]="'closingDate'" [inputDatepickerName]="'closingDate'"
                    (dateChanged)="selectedDates($event)"></app-input-datepicker-renderer>
            </div>
        </div>

    </div>
    <div class="modal-footer pt-3 pb-2 mx-2">
        <app-button class="my-0 me-3" (buttonOutputEvent)="dismiss()" [buttonLabel]="'Close'"
            [buttonClass]="'pink_button'" [buttonType]="'button'">
        </app-button>
        <app-button class="m-0" [buttonLabel]="'Save'" (buttonOutputEvent)="onSave()" [buttonClass]="'blue_button'"
            [buttonType]="'submit'">
        </app-button>
    </div>
</form>